import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useProfileContext } from "../contexts/ProfileContext";
import { Role } from "../core/models/entities/Role";

interface Props {
  element: JSX.Element;
  /** Let workshop-flagged users through (the target strips all prices itself).
      Ordering/checkout routes must NOT set this. */
  allowWorkshop?: boolean;
}

export default function CartRoute({ element, allowWorkshop = false }: Props): ReactElement {
  const { role, organization, workshopMode } = useProfileContext();

  if (role === Role.EndUser && organization?.hidePrices) {
    return <Navigate to="/" replace />;
  }
  if (workshopMode && !allowWorkshop) {
    return <Navigate to="/" replace />;
  }
  return element;
}
